var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 41,
    viewBox: "0 0 142 41",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.975 10.572c0-2.11-.637-3.166-1.912-3.166H6.817v25.188h1.246c1.275 0 1.912-1.055 1.912-3.166V10.572zm2.93-9.16c1.345.943 2.363 2.25 3.056 3.923.692 1.673 1.039 3.63 1.039 5.87v17.59c0 2.208-.347 4.157-1.04 5.846-.692 1.689-1.718 3.004-3.075 3.946C11.527 39.53 9.906 40 8.022 40H0V0h8.022c1.912 0 3.54.471 4.884 1.413zM111.537 0l.718 22.07h-.359L107.705 0H102v40h6.424l-.678-21.632h.359L112.135 40H118V0h-6.464zM121 0v40h12v-7.016h-5.298v-9.939h4.656V16.03h-4.656V7.016h5.057V0H121zM93.383.077H27.378c-4.039 0-7.313 3.31-7.313 7.392v25.229c0 4.082 3.274 7.392 7.313 7.392h66.005c4.04 0 7.313-3.31 7.313-7.392V7.469c0-4.082-3.274-7.392-7.313-7.392zm0 6.6c.432 0 .784.356.784.792v25.229a.789.789 0 0 1-.784.792H27.378a.789.789 0 0 1-.784-.792V7.469c0-.436.352-.792.784-.792h66.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.901 39.128a.81.81 0 0 1-.805-.814v-3.372a.81.81 0 0 1 .805-.814h3.336a.81.81 0 0 1 .805.814v3.372a.81.81 0 0 1-.805.814H136.9z",
    fill: "#FF5726"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneLogo);
export default __webpack_public_path__ + "static/media/done_logo.49837d659b42aeb155dcad45fbb8323d.svg";
export { ForwardRef as ReactComponent };